export enum BrowserName {
    CHROME = 'Chrome',
    FIREFOX = 'Firefox',
    SAFARI = 'Safari'
}
